import { useQuery } from '@apollo/client';
import { Controller, useFormContext } from 'react-hook-form';
import { graphql } from '~/apollo/generated/v4';
import { SimplePanel } from '~/components/common/Panel';
import { SpinnerIcon } from '~/components/common/SpinnerIcon';
import { Select } from '~/components/ui/forms/select';
import { TextInput } from '~/components/ui/forms/text-input';
import * as R from 'ramda';
import type { ChangeEvent } from 'react';
import { Checkbox } from '~/components/ui/forms/Checkbox';
import type { VftFormValues } from '~/utils/modules/vft';
import type { VftManagerVftType } from '~/routes/upload/vft-manager/vft-manager';
import { LifecycleStatusSelect } from '../lifecycle/lifecycle-status-select';

const OUTCROP_LIST_QUERY = graphql(`
  query outcropListQuery {
    outcropList {
      results {
        id
        name
      }
    }
  }
`);

export function VftFormFields({ vft }: { vft?: VftManagerVftType }) {
  const { setValue, register } = useFormContext<VftFormValues>();
  const { data, loading } = useQuery(OUTCROP_LIST_QUERY);

  if (loading) {
    return <SpinnerIcon />;
  }

  const outcropsOptions = data?.outcropList?.results || [];
  const sortedOutcropOptions = R.sortBy(oc => oc.name, outcropsOptions);
  const currentOutcropsId: string[] = vft ? vft.outcrops?.map(oc => oc.id) : [];

  function onChange(e: ChangeEvent<HTMLSelectElement>) {
    const options = e.target.options;
    const selected = Array.from(options).filter(o => o.selected);
    const selectedIds = selected.map(o => Number(o.value));
    setValue('outcrops', selectedIds);
  }

  return (
    <SimplePanel title="Create Virtual Field Trip">
      <TextInput {...register('name')} label="Name"/>
      <Select
        name={'Outcrops'}
        label="Outcrops"
        multiple={true}
        className={'select w-full min-h-92'}
        onChange={onChange}
        defaultValue={currentOutcropsId}
        options={sortedOutcropOptions.map(oc => {
          return {
            value: oc.id,
            label: oc.name,
          };
        })}
        required
      />
      <Checkbox {...register('outcropTour')} label="Outcrop Tour" />
      <Controller
        name="lifecycleStatus"
        render={({ field }) => (
          <LifecycleStatusSelect {...field} label="Status" />
        )}
      />
    </SimplePanel>
  );
}
